import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "@/components/motion";
import { img } from "@/lib/gallery";

export const DOCS = [
  { key: "commercial", slug: "fiche-commerciale", n: 5 },
  { key: "technical", slug: "fiche-technique", n: 6 },
  { key: "manual", slug: "manuel", n: 18 },
];

export const DocCards = () => {
  const { t } = useI18n();
  return (
    <div className="grid gap-4 md:grid-cols-3">
      {DOCS.map((d, i) => (
        <Reveal key={d.key} delay={i * 0.08}>
          <Link to={`/documentation/${d.slug}`} data-testid={`doc-card-${d.key}`} className="group block border border-white/12 bg-[#070C1A]/40">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={img(d.n)} alt={t.docs[d.key].title} className="h-full w-full object-cover transition-transform duration-[1.1s] group-hover:scale-105" />
            </div>
            <div className="p-6">
              <p className="font-mono text-xs text-[var(--gold)]">0{i + 1}</p>
              <p className="font-display mt-2 text-3xl font-extrabold uppercase">{t.docs[d.key].title}</p>
              <p className="mt-2 text-sm text-[var(--steel-dim)]">{t.docs[d.key].short}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--gold)]">
                {t.docs.open}<ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  );
};

export const DocsTeaser = () => {
  const { t } = useI18n();
  return (
    <section id="documentation" className="bg-[var(--night)] py-24 lg:py-32" data-testid="docs-teaser">
      <div className="container-x">
        <SectionHead index="10" eyebrow={t.docs.eyebrow} title={t.docs.title} className="mb-14" />
        <DocCards />
      </div>
    </section>
  );
};
